import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#595556",
      d: "M8 14.98a1.2 1.2 0 0 1-.454-.09 1.3 1.3 0 0 1-.4-.26L2.085 9.567q-.171-.18-.261-.4a1.2 1.2 0 0 1-.09-.454 1.22 1.22 0 0 1 .35-.854L7.147 2.8q.18-.182.4-.266.22-.086.454-.086t.459.086q.224.084.395.266l5.061 5.061q.181.17.266.395.086.224.086.459 0 .234-.086.454-.084.22-.266.4l-5.061 5.061q-.17.17-.395.261-.225.09-.459.09m.147-1.064 5.056-5.055q.05-.051.05-.147t-.05-.148L8.147 3.511q-.051-.05-.147-.05t-.147.05L2.797 8.566q-.05.052-.05.148t.05.147l5.056 5.055q.051.052.147.052t.147-.052M7.5 9.438h1V5.695h-1zm.5 1.744a.52.52 0 0 0 .382-.157.52.52 0 0 0 .156-.382.52.52 0 0 0-.156-.382.52.52 0 0 0-.382-.156.52.52 0 0 0-.382.156.52.52 0 0 0-.156.382q0 .226.156.382a.52.52 0 0 0 .382.157"
    }, null, -1)
  ])))
}
export default { render: render }